import paul from "../images/paultoll.png";

export default function ImagePaul() {
  return (
   <div className='avartar'>
      <img src={paul} alt='Paul Oluwatoni Ariyo-Adeoye' className='avatar--Img'/>
</div>
  )
}
